import { AdministerSkipMedicationItem } from "./AdministerSkipMedicationItem";
import { FlatList, Text, View } from "react-native";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { useResidentMedicationsContext } from "../provider/ResidentMedicationsProvider";
import { MedicationListFrequencyFilter } from "../molecules/MedicationListFrequencyFilter";

export function AdministerSkipMedicationList() {
  const { data, isFetching, frequencies, handleFrequencyChange } =
    useResidentMedicationsContext();

  return (
    <View>
      <FlatList
        contentContainerClassName="gap-3.5"
        data={data ?? []}
        ListHeaderComponent={
          <MedicationListFrequencyFilter
            filters={frequencies}
            onChangeFilters={handleFrequencyChange}
          />
        }
        keyExtractor={(item) => `${item.id}`}
        renderItem={({ item }) => (
          <AdministerSkipMedicationItem medication={item} />
        )}
        ListEmptyComponent={
          !isFetching ? (
            <Text className="text-center">
              This resident has no active medications
            </Text>
          ) : (
            <LoadingSpinner />
          )
        }
      />
    </View>
  );
}
